module.exports = __webpack_public_path__ + "img/tolaat_no.46045db4.png";